import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { ViewAccessTypeEnum } from '@smarttask-common/src/lib/models/View/Enum/ViewAccessTypeEnum';
import { ColumnBaseModel } from '@smarttask-common/src/lib/models/Table/ColumnBaseModel';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class ViewHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.view_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.view_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.view_create, (view_id: string, project_id: string, user_id: number) => {
            this.broadcast(SharedEventNameEnum.view_create, { view_id, project_id, user_id });
        });

        this.on(SharedEventNameEnum.view_update, (view_id: string) => {
            this.broadcast(SharedEventNameEnum.view_update, { view_id });
        });

        this.on(SharedEventNameEnum.view_name_update, (view_id: string, name: string) => {
            this.broadcast(SharedEventNameEnum.view_name_update, { view_id, name });
        });

        this.on(SharedEventNameEnum.view_access_update, (view_id: string, access_type: ViewAccessTypeEnum) => {
            this.broadcast(SharedEventNameEnum.view_access_update, { view_id, access_type });
        });

        this.on(SharedEventNameEnum.view_order_update, (view_id: string, order_index: number) => {
            this.broadcast(SharedEventNameEnum.view_order_update, { view_id, order_index });
        });

        this.on(SharedEventNameEnum.view_delete, (view_id: string) => {
            this.broadcast(SharedEventNameEnum.view_delete, { view_id });
        });

        this.on(SharedEventNameEnum.view_column_upsert, (view_id: string, column_base: ColumnBaseModel[]) => {
            this.broadcast(SharedEventNameEnum.view_column_upsert, { view_id, column_base });
        });

        this.on(SharedEventNameEnum.view_column_delete, (view_id: string, column_id: string) => {
            this.broadcast(SharedEventNameEnum.view_column_delete, { view_id, column_id });
        });
    };
}
